export const SET_CONFIG_PROCESSING = 'SET_CONFIG_PROCESSING'
export const SET_CONFIG_DATA = 'SET_CONFIG_DATA'
export const GET_CONFIG_DATA = 'GET_CONFIG_DATA'

export function setConfigProcessing (processing = true) {
  return {
    type: SET_CONFIG_PROCESSING,
    payload: processing,
  }
}

export function setConfigData ({ data, processing = false }) {
  return {
    type: SET_CONFIG_DATA,
    payload: { data, processing },
  }
}

export function getConfigData () {
  return {
    type: GET_CONFIG_DATA,
  }
}
